import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { InputWithIcon, Icon, DatePicker, BackdropLoader, SelectMenu, toast } from '@livable/saas-react-components';
import { Typography, Paper, Button, MenuItem, InputLabel, InputAdornment, FormControl, OutlinedInput, TextField, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import moment from 'moment/moment';
import { formatISO } from 'date-fns';
import { useStore } from 'src/stores';
import { AMFModal } from './AdminFeeModal';
import { AccountSetupFee } from './AccountSetupFee';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
import { APPFOLIO_PROPERTY_STEPS } from 'src/constants/property';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { DetailedStreetFinder } from 'src/components/general/DetailedStreetFinder';
import { useAccountSetupFeePrice } from 'src/utils/hooks/useAccountSetupFeePrice';
export const PropertyResidentsAndFeeSetup = observer(_ref => {
  var _store$address, _store$address2;
  let handleStep = _ref.handleStep,
    editMode = _ref.editMode,
    mutablePropertyId = _ref.mutablePropertyId,
    notCompletedPropertyId = _ref.notCompletedPropertyId,
    registerActionBack = _ref.registerActionBack,
    registerActionNext = _ref.registerActionNext;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    globalAdminFee = _useState4[0],
    setGlobalAdminFee = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    globalAdminFeeUI = _useState6[0],
    setGlobalAdminFeeUI = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    currentGlobalAdminFee = _useState8[0],
    setCurrentGlobalAdminFee = _useState8[1];
  const _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    adminGl = _useState0[0],
    setAdminGl = _useState0[1];
  const _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    paperStatementGl = _useState10[0],
    setPaperStatementGl = _useState10[1];
  const _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    glAccounts = _useState12[0],
    setGLAccounts = _useState12[1];
  const _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    globalGlAccounts = _useState14[0],
    setGlobalGlAccounts = _useState14[1];
  const _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    paperStatementGlAccounts = _useState16[0],
    setPaperStatementGlAccounts = _useState16[1];
  const _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    accountSetupFeeGl = _useState18[0],
    setAccountSetupFeeGl = _useState18[1];
  const _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    accountSetupFeeGlAccounts = _useState20[0],
    setAccountSetupFeeGlAccounts = _useState20[1];
  const _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    searchByResidentName = _useState22[0],
    setSearchByResidentName = _useState22[1];
  const _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    companyData = _useState24[0],
    setCompanyData = _useState24[1];
  const _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showCompanyAddressForm = _useState26[0],
    setShowCompanyAddressForm = _useState26[1];
  const _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    handleStartValidate = _useState28[0],
    setHandleStartValidate = _useState28[1];
  const handleGlobalAdminFeeChange = e => {
    if (+e.target.value <= 99.99 && /^\d+([.,]\d{0,2})?$|^$/.test(+e.target.value)) setCurrentGlobalAdminFee(e.target.value);
  };
  const handleGlobalAdminFeeBlur = () => {
    setGlobalAdminFeeUI(currentGlobalAdminFee);
  };
  const handleAdminGlAccountSearch = v => {
    const currentArray = [];
    glAccounts.map(i => {
      if (i.name.toLocaleLowerCase().includes(v.trim().toLocaleLowerCase())) {
        currentArray.push(i);
      }
    });
    setGlobalGlAccounts(currentArray);
  };
  const handleAccountSetupFeeGlAccountSearch = v => {
    const currentArray = [];
    glAccounts.map(i => {
      if (i.name.toLocaleLowerCase().includes(v.trim().toLocaleLowerCase())) {
        currentArray.push(i);
      }
    });
    setAccountSetupFeeGlAccounts(currentArray);
  };
  const handlePaperStatementGlAccountSearch = v => {
    const currentArray = [];
    glAccounts.map(i => {
      if (i.name.toLocaleLowerCase().includes(v.trim().toLocaleLowerCase())) {
        currentArray.push(i);
      }
    });
    setPaperStatementGlAccounts(currentArray);
  };
  const currentPropertyId = mutablePropertyId ? mutablePropertyId : notCompletedPropertyId ? notCompletedPropertyId : localStorage.getItem('livable_property_id');
  const accountSetupFeePrice = useAccountSetupFeePrice({
    propertyId: currentPropertyId,
    isEnabled: store.account.featureFlagsStore.getIsAccountSetupFeeEnabled
  });
  // doSubmit is registered once as the wizard's Next action, so it reads the price through a ref.
  const accountSetupFeePriceRef = useRef(accountSetupFeePrice);
  accountSetupFeePriceRef.current = accountSetupFeePrice;
  const doSubmit = useCallback(async () => {
    setIsLoaded(false);
    const data = [];
    const adminFeeData = [];
    store.addNewProperty.residentsSetup.residents.map(i => {
      const oldDate = i.billingStartDateOnly;
      const oldAdminFee = i.adminFee;
      const formResidency = store.addNewProperty.residentsSetup.residentsForm.find(fi => fi.residencyId === i.residencyId);
      if (oldAdminFee !== formResidency.adminFee) {
        if (formResidency.adminFee) {
          adminFeeData.push({
            residencyId: i.residencyId,
            adminFee: {
              value: +formResidency.adminFee,
              feeUnitType: FEE_UNIT_TYPES.fixedAmount
            }
          });
        } else {
          adminFeeData.push({
            residencyId: i.residencyId,
            adminFee: null
          });
        }
      }
      if (oldDate !== formResidency.billingStartDateOnly) {
        const currentDate = oldDate !== formResidency.billingStartDateOnly ? {
          billingStartDate: {
            value: formResidency.billingStartDateOnly
          }
        } : {};
        data.push(_objectSpread({
          residencyId: i.residencyId
        }, currentDate));
      }
    });
    if (data.length > 0) {
      const resp = await store.residencies.batchUpdateBillingSettingsAsync.run({
        list: data
      });
      if (!resp || !resp.isSuccessful) {
        setIsLoaded(true);
        return;
      }
    }
    if (adminGl && adminGl !== null && adminGl !== void 0 && adminGl.length || paperStatementGl && paperStatementGl !== null && paperStatementGl !== void 0 && paperStatementGl.length || accountSetupFeeGl && accountSetupFeeGl !== null && accountSetupFeeGl !== void 0 && accountSetupFeeGl.length) {
      let glUpdateData = {
        properties: []
      };
      if (adminGl && adminGl !== null && adminGl !== void 0 && adminGl.length) {
        glUpdateData.properties.push({
          propertyLivableId: currentPropertyId,
          adminFeeGlAccountExternalId: {
            value: adminGl
          }
        });
      }
      if (paperStatementGl && paperStatementGl !== null && paperStatementGl !== void 0 && paperStatementGl.length) {
        glUpdateData.properties.push({
          propertyLivableId: currentPropertyId,
          paperStatementFeeGlAccountExternalId: {
            value: paperStatementGl
          }
        });
      }
      if (accountSetupFeeGl && accountSetupFeeGl !== null && accountSetupFeeGl !== void 0 && accountSetupFeeGl.length) {
        glUpdateData.properties.push({
          propertyLivableId: currentPropertyId,
          accountSetupFeeGlAccountExternalId: {
            value: accountSetupFeeGl
          }
        });
      }
      await store.credentials.patchAppfolioPropertiesAsync.run(glUpdateData);
    }

    // An absent key leaves that fee as it stands, so each one is only sent when there is something
    // to say about it: the admin fee when it changed, the setup fee whenever this property can
    // carry one (a null price means the flag is off or the product is not on its subscription).
    const feeUpdates = {};
    if (globalAdminFee !== currentGlobalAdminFee) {
      feeUpdates.adminFee = {
        value: currentGlobalAdminFee ? currentGlobalAdminFee : null,
        feeUnitType: FEE_UNIT_TYPES.fixedAmount
      };
    }
    if (accountSetupFeePriceRef.current !== null) {
      var _store$addNewProperty, _store$addNewProperty2;
      feeUpdates.accountSetupFee = {
        value: (_store$addNewProperty = (_store$addNewProperty2 = store.addNewProperty.feeStructureV2.getPropertyFee({
          feeName: 'accountSetupFee'
        })) === null || _store$addNewProperty2 === void 0 ? void 0 : _store$addNewProperty2.value) !== null && _store$addNewProperty !== void 0 ? _store$addNewProperty : null
      };
    }
    if (Object.keys(feeUpdates).length > 0) {
      await store.properties.updatePropertyFeesV2Async.run(_objectSpread({
        propertyId: currentPropertyId
      }, feeUpdates));
    }
    if (adminFeeData.length > 0) {
      await store.properties.setResidenciesFeesAsync.run({
        data: adminFeeData
      });
    }
    setIsLoaded(true);
    if (mutablePropertyId) {
      toast('success', {
        body: ['Successfully saved']
      });
    }
    if (!mutablePropertyId) {
      await store.properties.updatePropertySetupProgressAsync.run({
        propertyId: currentPropertyId,
        propertySetupStep: Object.keys(APPFOLIO_PROPERTY_STEPS).find(key => APPFOLIO_PROPERTY_STEPS[key] === APPFOLIO_PROPERTY_STEPS.FeeSetup)
      });
      store.addNewProperty.changeCompletedStep(APPFOLIO_PROPERTY_STEPS.PayoutDetails);
      handleStep(APPFOLIO_PROPERTY_STEPS.PayoutDetails)();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminGl, paperStatementGl, accountSetupFeeGl, currentGlobalAdminFee, globalAdminFee, currentPropertyId, mutablePropertyId, store]);
  const handlebillingStartDateOnly = (id, date) => {
    store.addNewProperty.residentsSetup.changeBillingStartDateOnly(id, date ? formatISO(date).split('T')[0] : null);
  };
  const fetchData = async () => {
    var _singleElementOfArray, _residenciesResp$resp, _propertyFeesResp$res;
    setAdminGl([]);
    setGLAccounts([]);
    setGlobalGlAccounts([]);
    setPaperStatementGlAccounts([]);
    setAccountSetupFeeGlAccounts([]);
    const buildingsData = await store.buildings.getBuildingAsync.run({
      propertyId: currentPropertyId
    });
    const currentBuildingId = (_singleElementOfArray = singleElementOfArray(buildingsData === null || buildingsData === void 0 ? void 0 : buildingsData.response)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.id;
    const residenciesResp = await store.residencies.getAllResidenciesRelatedToSpecificBuildingAggregateAsync.run({
      buildingId: currentBuildingId,
      includeEmptyUnits: false,
      searchQuery: '',
      sortBy: 'Unitname',
      sortOrder: 'Asc',
      statuses: [RESIDENCY_STATUS_KEY_VALUES.Current]
    });
    const currentResidencydIds = [];
    if (residenciesResp !== null && residenciesResp !== void 0 && (_residenciesResp$resp = residenciesResp.response) !== null && _residenciesResp$resp !== void 0 && (_residenciesResp$resp = _residenciesResp$resp.buildingResidency) !== null && _residenciesResp$resp !== void 0 && _residenciesResp$resp.length) {
      var _residenciesResp$resp2;
      residenciesResp === null || residenciesResp === void 0 || (_residenciesResp$resp2 = residenciesResp.response) === null || _residenciesResp$resp2 === void 0 || _residenciesResp$resp2.buildingResidency.map(rI => currentResidencydIds.push(rI.residencyId));
    }
    const residenciesFeesResp = await store.properties.getResidenciesFeesAsync.run({
      residencydIds: currentResidencydIds
    });
    const glProperties = await store.credentials.getAppfolioPropertiesAsync.run({});
    const currentGlProperty = glProperties.response.find(glItem => glItem.propertyLivableId === currentPropertyId);
    if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.adminFeeGlAccountExternalId) {
      setAdminGl(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.adminFeeGlAccountExternalId);
    }
    if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.paperStatementFeeGlAccountExternalId) {
      setPaperStatementGl(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.paperStatementFeeGlAccountExternalId);
    }
    if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.accountSetupFeeGlAccountExternalId) {
      setAccountSetupFeeGl(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.accountSetupFeeGlAccountExternalId);
    }
    await store.credentials.getGLAccountsAsync.run({
      applyToHomeDashboard: false
    }).then(glResp => {
      if (glResp && glResp !== null && glResp !== void 0 && glResp.isSuccessful) {
        setGLAccounts(glResp.response);
        setGlobalGlAccounts(glResp.response);
        setPaperStatementGlAccounts(glResp.response);
        setAccountSetupFeeGlAccounts(glResp.response);
      }
    });
    const propertyFeesResp = await store.properties.getPropertyFeesV2Async.run({
      applyToStore: true,
      applyToHomeDashboard: false,
      propertyId: currentPropertyId
    });
    if (propertyFeesResp && propertyFeesResp !== null && propertyFeesResp !== void 0 && propertyFeesResp.response && propertyFeesResp !== null && propertyFeesResp !== void 0 && (_propertyFeesResp$res = propertyFeesResp.response) !== null && _propertyFeesResp$res !== void 0 && (_propertyFeesResp$res = _propertyFeesResp$res.adminFee) !== null && _propertyFeesResp$res !== void 0 && _propertyFeesResp$res.value) {
      setGlobalAdminFee(propertyFeesResp.response.adminFee.value);
      setGlobalAdminFeeUI(propertyFeesResp.response.adminFee.value);
      setCurrentGlobalAdminFee(propertyFeesResp.response.adminFee.value);
    }
    if (residenciesResp && residenciesResp.response && residenciesFeesResp && residenciesFeesResp.response) {
      var _residenciesResp$resp3;
      store.addNewProperty.residentsSetup.setResidents(residenciesResp === null || residenciesResp === void 0 || (_residenciesResp$resp3 = residenciesResp.response) === null || _residenciesResp$resp3 === void 0 ? void 0 : _residenciesResp$resp3.buildingResidency, residenciesFeesResp.response);
      setIsLoaded(true);
    }
    const companyResp = await store.company.getCurrentUserCompanyFromTokenAsync.run();
    if (companyResp && companyResp.isSuccessful) {
      setCompanyData(companyResp.response);
    }
  };
  const submitForm = useCallback(async () => {
    if (paperStatementGl && !(companyData !== null && companyData !== void 0 && companyData.addressId)) {
      setShowCompanyAddressForm(true);
      setHandleStartValidate(true);
      return;
    }
    await doSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paperStatementGl, companyData === null || companyData === void 0 ? void 0 : companyData.addressId, doSubmit]);
  const handleStartSubmitting = async newAddressId => {
    let data = {
      companyType: companyData.companyType,
      name: companyData.name,
      propertyManagementSoftware: companyData.propertyManagementSoftware || '',
      addressId: newAddressId
    };
    if (newAddressId) {
      const addressResp = await store.address.batchGetAddressesAsync.run({
        addressIds: [newAddressId]
      });
      if (addressResp && addressResp.isSuccessful) {
        var _addressResp$response;
        data.postalAddress = "".concat(addressResp.response[0].street, " ").concat(addressResp.response[0].city, ", ").concat(addressResp.response[0].state, " ").concat(addressResp.response[0].zip).concat((_addressResp$response = addressResp.response[0]) !== null && _addressResp$response !== void 0 && _addressResp$response.secondary ? ', ' + addressResp.response[0].secondary : '');
      }
    }
    const resp = await store.company.updateCompanyAsync.run(data);
    if (resp && resp.isSuccessful) {
      setCompanyData(_objectSpread(_objectSpread({}, companyData), {}, {
        addressId: newAddressId
      }));
      setShowCompanyAddressForm(false);
      toast('success', {
        body: ['Company address saved']
      });
    }
    await doSubmit();
  };
  const handleEndSubmitting = () => {
    setHandleStartValidate(false);
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (registerActionBack !== undefined) registerActionBack(() => {
      handleStep(APPFOLIO_PROPERTY_STEPS.UnitSetup)();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionBack]);
  useEffect(() => {
    if (registerActionNext !== undefined) registerActionNext(() => {
      submitForm();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionNext, submitForm]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('Residents & fee setup')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('Fee setup')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('You can charge residents with fee when needed. Assign the amount you want the resident to pay, where legally allowed. We suggest an admin fee be a fair amount, admin fees are used to offset your subscription costs. Please also select your admin fee GL account form the list.'))), /*#__PURE__*/React.createElement("div", {
    className: classes.feeSetup
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.feeSetupWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.feeSetupCharge
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: handleGlobalAdminFeeChange
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "resident-payment"
  }, t('Resident charge')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "resident-payment",
    label: t('Resident charge'),
    type: "number",
    value: currentGlobalAdminFee,
    placeholder: "Not set",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    onBlur: handleGlobalAdminFeeBlur
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.feeSetupGl
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "gl-selector",
    enableSearch: true,
    labelId: "gl-selector-label",
    label: "Select admin fee GL account",
    disabled: glAccounts.length === 0,
    onSearch: handleAdminGlAccountSearch,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => {
      setAdminGl(e.target.value);
      setGlobalGlAccounts(glAccounts);
    },
    value: adminGl,
    renderValue: selected => {
      var _globalGlAccounts$fin;
      if (selected.length === 0) {
        return '';
      }
      return (_globalGlAccounts$fin = globalGlAccounts.find(item => item.externalId === selected)) === null || _globalGlAccounts$fin === void 0 ? void 0 : _globalGlAccounts$fin.name;
    }
  }, globalGlAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number))))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: !isLoaded
  })), accountSetupFeePrice !== null && /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(AccountSetupFee, {
    isLoaded: isLoaded,
    price: accountSetupFeePrice
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    enableSearch: true,
    id: "account-setup-fee-gl-selector",
    labelId: "account-setup-fee-gl-selector-label",
    label: "Select account setup fee GL account",
    disabled: glAccounts.length === 0,
    onSearch: handleAccountSetupFeeGlAccountSearch,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => {
      setAccountSetupFeeGl(e.target.value);
      setAccountSetupFeeGlAccounts(glAccounts);
    },
    value: accountSetupFeeGl,
    renderValue: selected => {
      var _accountSetupFeeGlAcc;
      if (selected.length === 0) {
        return '';
      }
      return (_accountSetupFeeGlAcc = accountSetupFeeGlAccounts.find(item => item.externalId === selected)) === null || _accountSetupFeeGlAcc === void 0 ? void 0 : _accountSetupFeeGlAcc.name;
    }
  }, accountSetupFeeGlAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number)))))), store.account.featureFlagsStore.getIsAppfolioPaperStatementFeeEnabled && /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('Paper statement GL code')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('Electronic statements and invites are free. Statements and invites sent by US Mail cost $2 each for postage and handling.'))), /*#__PURE__*/React.createElement("div", {
    className: classes.feeSetup
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.feeSetupWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.feeSetupGl
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    enableSearch: true,
    id: "paper-statement-gl-selector",
    disabled: glAccounts.length === 0,
    label: "Select paper statement GL account",
    labelId: "paper-statement-gl-selector-label",
    onSearch: handlePaperStatementGlAccountSearch,
    searchPlaceholder: 'Search account by name or number',
    onChange: e => {
      setPaperStatementGl(e.target.value);
      setPaperStatementGlAccounts(glAccounts);
      if (!(companyData !== null && companyData !== void 0 && companyData.addressId)) {
        setShowCompanyAddressForm(true);
        toast('info', {
          body: ['Please enter your company address first to enable Paper Statements.']
        });
      }
    },
    value: paperStatementGl,
    renderValue: selected => {
      var _paperStatementGlAcco;
      if (selected.length === 0) {
        return '';
      }
      return (_paperStatementGlAcco = paperStatementGlAccounts.find(item => item.externalId === selected)) === null || _paperStatementGlAcco === void 0 ? void 0 : _paperStatementGlAcco.name;
    }
  }, paperStatementGlAccounts.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.externalId,
    className: classes.glAccountItem
  }, /*#__PURE__*/React.createElement("span", null, i.name), /*#__PURE__*/React.createElement("i", null, "number: ", i.number)))))), showCompanyAddressForm && !(companyData !== null && companyData !== void 0 && companyData.addressId) && /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    gutterBottom: true
  }, t('Please enter your company address')), /*#__PURE__*/React.createElement(DetailedStreetFinder, {
    name: "postalAddress",
    defaultPropertyAddress: {},
    disabled: store.company.updateCompanyAsync.inProgress,
    _serviceVariableValidate: handleStartValidate,
    _serviceStopValidate: () => setHandleStartValidate(false),
    _serviceStartSubmitting: handleStartSubmitting,
    _serviceEndSubmitting: handleEndSubmitting
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: !isLoaded || ((_store$address = store.address) === null || _store$address === void 0 || (_store$address = _store$address.addNewAddressAsync) === null || _store$address === void 0 ? void 0 : _store$address.inProgress) || ((_store$address2 = store.address) === null || _store$address2 === void 0 || (_store$address2 = _store$address2.updateAddressAsync) === null || _store$address2 === void 0 ? void 0 : _store$address2.inProgress) || store.company.updateCompanyAsync.inProgress
  })), !editMode && /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.residents
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.residentsWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.residentsSearch
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    type: "text",
    variant: "outlined",
    value: searchByResidentName,
    label: t('Search for resident'),
    onChange: e => setSearchByResidentName(e.target.value)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.residentsTable
  }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Unit"), /*#__PURE__*/React.createElement(TableCell, null, "Resident name"), /*#__PURE__*/React.createElement(TableCell, null, "Admin fee"), /*#__PURE__*/React.createElement(TableCell, null, "Billing start date"))), /*#__PURE__*/React.createElement(TableBody, null, store.addNewProperty.residentsSetup.residentsForm.map(i => {
    if (i.unitName.toLocaleLowerCase().includes(searchByResidentName.toLocaleLowerCase()) || i.fullname.toLocaleLowerCase().includes(searchByResidentName.toLocaleLowerCase())) {
      return /*#__PURE__*/React.createElement(TableRow, {
        key: i.residencyId
      }, /*#__PURE__*/React.createElement(TableCell, null, i.unitName), /*#__PURE__*/React.createElement(TableCell, null, i.fullname), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", {
        className: classes.amf
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.amfValue, " ").concat(i.adminFee !== null && i.adminFee !== 'null' && +i.adminFee !== +globalAdminFeeUI ? 'custom' : '')
      }, /*#__PURE__*/React.createElement("b", null, !i.adminFee || i.adminFee === null || i.adminFee === 'null' ? globalAdminFeeUI ? "$".concat(globalAdminFeeUI) : 'N/A' : "$".concat(i.adminFee)), i.adminFee !== null && i.adminFee !== 'null' && +i.adminFee !== +globalAdminFeeUI && /*#__PURE__*/React.createElement("span", null, "Custom")), /*#__PURE__*/React.createElement("div", {
        className: classes.amfControll
      }, /*#__PURE__*/React.createElement(AMFModal, {
        defaultAdminFee: globalAdminFeeUI,
        adminFee: i.adminFee,
        residencyId: i.residencyId
      })))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", {
        className: classes.input
      }, /*#__PURE__*/React.createElement(DatePicker, {
        format: "MM/dd/yy",
        label: t('general.start_date'),
        onChange: date => handlebillingStartDateOnly(i.residencyId, date),
        value: i.billingStartDateOnly ? moment(i.billingStartDateOnly).toDate() : null
      }))));
    }
  }))))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: !isLoaded
  })), !editMode && registerActionBack === undefined && registerActionNext === undefined && /*#__PURE__*/React.createElement("div", {
    className: classes.pageFooter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleStep(APPFOLIO_PROPERTY_STEPS.UnitSetup),
    disabled: !isLoaded,
    'custom-attribute': '133-property-residents-and-fee-setup'
  }, t('general.back')), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "priority",
    onClick: submitForm,
    disabled: !isLoaded,
    'custom-attribute': '134-property-residents-and-fee-setup'
  }, t('buttons.confirm'), ". ", t('general.next'))), editMode && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "priority",
    onClick: submitForm,
    'custom-attribute': '135-property-residents-and-fee-setup'
  }, t('buttons.save'))));
});